export interface IRegistrationFields {
	identifier: string;
	autocomplete: 'given-name' | 'family-name' | 'username' | 'new-password';
	category: 'input' | 'select' | 'datepicker' | 'checkbox';
	type?: 'text' | 'password' | 'email';
	label: string;
	autoCapitalize: boolean;
}

export const registrationFields: IRegistrationFields[] = [
	{
		identifier: 'first_name',
		autocomplete: 'given-name',
		category: 'input',
		type: 'text',
		label: 'auth.fields.firstName',
		autoCapitalize: true,
	},
	{
		identifier: 'last_name',
		autocomplete: 'family-name',
		category: 'input',
		type: 'text',
		label: 'auth.fields.lastName',
		autoCapitalize: true,
	},
	{
		identifier: 'email',
		autocomplete: 'username',
		category: 'input',
		type: 'email',
		label: 'auth.fields.email',
		autoCapitalize: false,
	},
	{
		identifier: 'password',
		autocomplete: 'new-password',
		category: 'input',
		type: 'password',
		label: 'auth.fields.password',
		autoCapitalize: false,
	},
];

export interface RegistrationState {
	first_name: string;
	last_name: string;
	email: string;
	password: string;
}

export class RegistrationState {
	constructor(object?: Partial<RegistrationState>) {
		this.first_name = object?.first_name || '';
		this.last_name = object?.last_name || '';
		this.email = object?.email || '';
		this.password = object?.password || '';
	}
}
